import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../components/ui/dialog';

export function CreateCommissionDialog({ open, onOpenChange, form, setForm, prospects, onCreate }) {
    const updateField = (field, value) => {
        setForm({ ...form, [field]: value });
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Nouvelle Commission</DialogTitle>
                </DialogHeader>
                <div className="space-y-4 py-4">
                    <div>
                        <Label>Dossier</Label>
                        <Select value={form.dossier_id} onValueChange={(v) => updateField('dossier_id', v)}>
                            <SelectTrigger data-testid="dossier-select">
                                <SelectValue placeholder="Sélectionner" />
                            </SelectTrigger>
                            <SelectContent>
                                {prospects.map((p) => (
                                    <SelectItem key={p.id} value={p.id}>
                                        {p.company_name || p.first_name}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <Label>Pipeline</Label>
                        <Select value={form.pipeline_type} onValueChange={(v) => updateField('pipeline_type', v)}>
                            <SelectTrigger data-testid="pipeline-select">
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="easy_power">Courtage</SelectItem>
                                <SelectItem value="chantier">Travaux d’optimisation</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                    <div>
                        <Label>Montant (€)</Label>
                        <Input 
                            type="number" 
                            value={form.montant_global} 
                            onChange={(e) => updateField('montant_global', e.target.value)}
                            data-testid="montant-input"
                        />
                    </div>
                    <div>
                        <Label>Mode Paiement VP</Label>
                        <Select value={form.vp_payment_mode} onValueChange={(v) => updateField('vp_payment_mode', v)}>
                            <SelectTrigger data-testid="payment-mode-select">
                                <SelectValue />
                            </SelectTrigger>
                            <SelectContent>
                                <SelectItem value="split_50_50">Split 50/50</SelectItem>
                                <SelectItem value="valnexo_only">Valnexo 100%</SelectItem>
                                <SelectItem value="at_only">AT 100%</SelectItem>
                            </SelectContent>
                        </Select>
                    </div>
                </div>
                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)}>Annuler</Button>
                    <Button onClick={onCreate} data-testid="create-commission-btn">Créer</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
